const DEFAULT_CONFIG = {
	//标题
	TITLE: "process.env.VUE_APP_TITLE",

	//首页地址
	DASHBOARD_URL: "/dashboard",

	//版本号
	APP_VER: "1.6.2",

	//内核版本号
	CORE_VER: "1.6.2",
}
module.exports = DEFAULT_CONFIG